import './App.css'
import { Stack, ThemeProvider, Toolbar } from '@mui/material'
import React, { useMemo } from 'react'
import { useAuth, withAuthenticationRequired } from 'react-oidc-context'
import { com } from '@eidu/form'
import { EntityTypesProvider } from './io/context/EntityTypes'
import LandingPage from './pages/LandingPage'
import { createEiduTheme } from './ui/theme/eiduTheme'
import { getTheme, getThemeConfig } from './ui/theme/themeConfig'
import TopAppBar from './components/layout/TopAppBar'
import { useLogAuthContext } from './util/Debug'
import { FormErrorProvider } from './util/FormErrorBus'
import ScreenSpanTracker from './otel/ScreenSpanTracker'
import { extractProfileClaims } from './io/api/authorization/profileClaims'
import { CompactNavigationProvider } from './components/layout/CompactNavigationContext'
import entityIdFromString = com.eidu.sharedlib.entity.entityIdFromString

const App = () => {
  useLogAuthContext()
  const auth = useAuth()

  const { organizationId, userEntityId } = auth.user?.profile
    ? extractProfileClaims(auth.user.profile)
    : { organizationId: undefined, userEntityId: undefined }
  const theme = getTheme(organizationId)
  const themeConfig = getThemeConfig(theme)
  const eiduTheme = useMemo(() => createEiduTheme(themeConfig.primaryMain), [themeConfig.primaryMain])

  return (
    <FormErrorProvider>
      <EntityTypesProvider>
        <ScreenSpanTracker organizationId={organizationId} userEntityId={userEntityId} />
        <ThemeProvider theme={eiduTheme}>
          <CompactNavigationProvider>
            <Stack className="app">
              <TopAppBar
                userEntityId={userEntityId ? entityIdFromString(userEntityId) : undefined}
                signOut={() => auth.signoutRedirect()}
                theme={theme}
              />
              <Toolbar />
              <Stack sx={{ flex: 1, minHeight: 0 }}>
                <LandingPage />
              </Stack>
            </Stack>
          </CompactNavigationProvider>
        </ThemeProvider>
      </EntityTypesProvider>
    </FormErrorProvider>
  )
}

export default withAuthenticationRequired(App)
